import React, { useState, useEffect } from 'react';
import MarkdownContent from '../components/MarkdownContent';
import { ArrowLeft } from 'lucide-react';

const PostPage = ({ slug, onGoBack }) => {
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!slug) return;
        
        fetch('/content/blog/posts.json')
            .then(res => res.json())
            .then(allPosts => {
                const currentPost = allPosts.find(p => p.slug === slug);
                setPost(currentPost);
                setLoading(false);
            })
            .catch(err => {
                console.error("Failed to load post metadata:", err);
                setLoading(false);
            });
    }, [slug]);

    if (loading) {
        return <div className="text-center">Loading post...</div>;
    }

    if (!post) {
        return <div className="text-center">Post not found.</div>;
    }

    return (
        <div className="max-w-3xl mx-auto">
            <button onClick={onGoBack} className="flex items-center text-sm font-semibold text-blue-600 hover:text-blue-500 mb-6">
                <ArrowLeft size={16} className="mr-1" /> Back to All Posts
            </button>
            <h1 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-cyan-400">{post.title}</h1>
            <p className="text-md text-gray-500 dark:text-gray-500 mt-2">By {post.author} on {new Date(post.date).toLocaleDateString()}</p>
            
            <div className="mt-8 border-t border-gray-200 dark:border-gray-700 pt-8">
                <MarkdownContent file={`blog/${post.fileName}`} />
            </div>
        </div>
    );
};

export default PostPage;